import {styled} from "@mui/system";
import {NavLink} from "react-router";

const StyledNavLink = styled(NavLink)(({theme}) => ({
  ...theme.mixins.toolbar,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: 'inherit',
  textDecoration: 'none',
  fontSize: '20px',
  '&.active': {
    textDecoration: 'underline',
    textDecorationColor: theme.palette.text.primary,
    textDecorationThickness: 1.5,
  }
}))

export {StyledNavLink};